module.exports = __webpack_public_path__ + "static/img/logo.a0540ce0.svg";